// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('provider/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/provider/providerList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getProvider = createAsyncThunk('provider/getProvider', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/provider/providerEdit/${id}`)
    return response.data.Response.item
  } else {
    return response
  }
})

export const addProvider = createAsyncThunk('provider/addProvider', async (CreateProvider, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/provider/providerCreate`, {
    Request: {
      CreateProvider
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().providers.params))
  await dispatch(getAllData())
  return CreateProvider
})

export const updateProvider = createAsyncThunk('provider/addProvider', async (UpdateProvider, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/provider/providerUpdate`, {
    Request: {
      UpdateProvider
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().providers.params))
  await dispatch(getAllData())
  return UpdateProvider
})

export const changeStatus = createAsyncThunk('provider/changeStatus', async (ChangeStatusProvider, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/provider/providerChangeStatus`, {
    Request: {
      ChangeStatusProvider
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().providers.params))
  return ChangeStatusProvider
})

export const deleteProvider = createAsyncThunk('provider/deleteProvider', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/provider/providerDelete/${id}`)

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().providers.params))
  await dispatch(getAllData())
  return id
})

export const appCategoriesSlice = createSlice({
  name: 'providers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedProvider: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getProvider.fulfilled, (state, action) => {
        state.selectedProvider = action.payload
      })
  }
})

export default appCategoriesSlice.reducer
